import { MiscScreen } from '@bonanza-social/navigation';

function TermsAndConditionsScreen() {
  return <MiscScreen path="/terms" />;
}

export default TermsAndConditionsScreen;
